export default "__VITE_PUBLIC_ASSET__15053f00__"